import { render, staticRenderFns } from "./NoticeSendRecord.vue?vue&type=template&id=aa797024&scoped=true"
import script from "./NoticeSendRecord.vue?vue&type=script&lang=js"
export * from "./NoticeSendRecord.vue?vue&type=script&lang=js"
import style0 from "./NoticeSendRecord.vue?vue&type=style&index=0&id=aa797024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa797024",
  null
  
)

export default component.exports